import React from "react";
import { connect } from "react-redux";
import { MenuItemLink } from "react-admin";
import { withRouter } from "react-router-dom";
import PermIdentity from "@material-ui/icons/PermIdentity";
import MotorCycle from "@material-ui/icons/Motorcycle";
import EventSeat from "@material-ui/icons/EventSeat";
import SwapHoriz from "@material-ui/icons/SwapHoriz";
import Navigation from "@material-ui/icons/Navigation";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Map from "@material-ui/icons/Map";
import Timelapse from "@material-ui/icons/Timelapse";
import Receipt from "@material-ui/icons/Receipt";
import Lock from "@material-ui/icons/Lock";
import Face from "@material-ui/icons/Face";
import Polymer from "@material-ui/icons/Polymer";
import LocalGasStation from "@material-ui/icons/LocalGasStation";
import Pantool from "@material-ui/icons/PanTool";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ThumbDown from "@material-ui/icons/ThumbDown";
import Announcement from "@material-ui/icons/Announcement";
import WatchLater from "@material-ui/icons/WatchLater";
import Error from "@material-ui/icons/Error";
import AttachMoney from "@material-ui/icons/AttachMoney";
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import AirportShuttle from "@material-ui/icons/AirportShuttle";
import People from '@material-ui/icons/People';
import PeopleOutline from '@material-ui/icons/PeopleOutline';
import { canAccess } from "./rbac";

const MENU_ITEMS = [
  { to: "/", text: "Dashboard", icon: <DashboardIcon />, permission: "dashboard" },
  { to: "/payments", text: "Payments", icon: <AttachMoney />, permission: "payments" },
  { to: "/clients", text: "Clients", icon: <PermIdentity />, permission: "clients" },
  { to: "/agencies", text: "Agencies", icon: <PeopleOutline />, permission: "agencies" },
  { to: "/clientsMerge", text: "Merge Accounts", icon: <People />, permission: "clientsMerge" },
  { to: "/tour_due_list", text: "Tour Due", icon: <Announcement />, permission: "tour_due_list" },
  { to: "/tour-management", text: "Pending tour Bookings", icon: <WatchLater />, permission: "tour_management" },
  { to: "/tours", text: "Tours Whiteboard", icon: <Map />, permission: "tours" },
  { to: "/pending_rentals", text: "Pending Rentals", icon: <WatchLater />, permission: "pending_rentals" },
  { to: "/rentals_due", text: "Rentals Due", icon: <Announcement />, permission: "rentals_due" },
  { to: "/whiteboard", text: "Rentals Whiteboard", icon: <Map />, permission: "whiteboard" },
  { to: "/moto_schedule/start", text: "Bike Schedule", icon: <MotorCycle />, permission: "moto_schedule" },
  { to: "/gps_schedule/start", text: "Gps Schedule", icon: <Navigation />, permission: "gps_schedule" },
  { to: "/vans_schedule/start", text: "Vans Schedule", icon: <AirportShuttle />, permission: "vans_schedule" },
  { to: "/weekly_rentals", text: "Weekly Rentals", icon: <LocalOffer />, permission: "weekly_rentals" },
  { to: "/transfers", text: "Transfers", icon: <SwapHoriz />, permission: "transfers" },
  { to: "/current_fleet", text: "Current Fleet", icon: <Lock />, permission: "current_fleet" },
  { to: "/fleet_allocation", text: "Fleet Allocation", icon: <MotorCycle />, permission: "fleet_allocation" },
  { to: "/tour_prices", text: "Tour List and Prices", icon: <Receipt />, permission: "tour_prices" },
  { to: "/tour_list", text: "Tour List", icon: <Timelapse />, permission: "tour_list" },
  { to: "/rentals", text: "Rental List", icon: <Timelapse />, permission: "rentals" },
  { to: "/vehicles", text: "Vehicles", icon: <MotorCycle />, permission: "vehicles" },
  { to: "/gps_devices", text: "Gps", icon: <Navigation />, permission: "gps_devices" },
  { to: "/holds", text: "Holds", icon: <Lock />, permission: "holds" },
  { to: "/unentered_km_rentals", text: "Unentered KM", icon: <Timelapse />, permission: "unentered_km_rentals" },
  { to: "/extra_km_rentals", text: "Extra KM Rentals", icon: <Timelapse />, permission: "extra_km_rentals" },
  { to: "/vehicle_damages", text: "Damages", icon: <Error />, permission: "vehicle_damages" },
  { to: "/black_lists", text: "Black List", icon: <ThumbDown />, permission: "black_lists" },
  { to: "/reports", text: "Reports", icon: <ArrowDownwardIcon />, permission: "reports" },
  { to: "/seats", text: "Seats", icon: <EventSeat />, permission: "seats" },
  { to: "/tankbags", text: "Tankbags", icon: <LocalGasStation />, permission: "tankbags" },
  { to: "/gloves", text: "Gloves", icon: <Pantool />, permission: "gloves" },
  { to: "/helmets", text: "Helmets", icon: <Face />, permission: "helmets" },
  { to: "/jackets", text: "Jackets", icon: <Polymer />, permission: "jackets" },
];

const MyMenu = ({ onMenuClick }) => (
  <div>
    {MENU_ITEMS.map(({ to, text, icon, permission }) =>
      canAccess(permission) ? (
        <MenuItemLink
          key={to}
          to={to}
          primaryText={text}
          onClick={onMenuClick}
          leftIcon={icon}
        />
      ) : null
    )}
  </div>
);

const mapStateToProps = () => ({});

export default withRouter(connect(mapStateToProps)(MyMenu));



// WEBPACK FOOTER //
// ./src/MyMenu.js